import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Key } from 'lucide-react';

const CATEGORIES = [
  'Academia e Esporte', 'Beleza Feminina', 'Beleza Masculina', 'Estética e Bem-estar',
  'Moda e Acessórios', 'Infantil e RN', 'Saúde', 'Saúde Veterinária',
  'Pet Shop', 'Casa e Decoração', 'Construção e Reforma', 'Eletrônicos e Tecnologia',
  'Veículos Elétricos', 'Carro e Motos', 'Gastronomia e Bebidas', 'Manutenção e Reparos',
  'Lazer e Diversão', 'Educação e Ensino'
];

const PLANS = [
  { id: 'gratuito', label: 'Gratuito', price: 'Grátis', limit: '10 cupons/mês', color: 'bg-slate-100 border-slate-300' },
  { id: 'premium', label: 'Premium', price: 'R$ 150/mês', limit: '30 cupons/mês', color: 'bg-blue-50 border-blue-300' },
  { id: 'platinum', label: 'Platinum', price: 'R$ 300/mês', limit: '50 cupons/mês', color: 'bg-purple-50 border-purple-300' },
  { id: 'black', label: 'Black', price: 'R$ 750/mês', limit: '80 cupons/mês', color: 'bg-slate-900 border-slate-700 text-white' },
];

const STATES = [
  'AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA',
  'PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'
];

export const ProfileMerchantFields = ({
  whatsapp, setWhatsapp, companyName, setCompanyName, cnpj, setCnpj,
  merchantCategory, setMerchantCategory, contactName, setContactName,
  state, setState, city, citySearch, setCitySearch, setCity,
  showCitySuggestions, setShowCitySuggestions, filteredCities, handleCitySelect, cityRef,
  neighborhood, setNeighborhood, commercialAddress, setCommercialAddress,
  plan, onContractPlan
}) => (
  <div className="space-y-4 pt-2 border-t border-slate-200">
    <h2 className="text-lg font-bold text-slate-900">Dados da Empresa</h2>
    <div><Label>Nome da Empresa</Label><Input value={companyName} onChange={e => setCompanyName(e.target.value)} required data-testid="company-name-input" className="mt-1" /></div>
    <div><Label>CNPJ</Label><Input value={cnpj} onChange={e => setCnpj(e.target.value)} placeholder="00.000.000/0000-00" required data-testid="cnpj-input" className="mt-1" /></div>
    <div>
      <Label>Categoria do Negócio</Label>
      <Select value={merchantCategory} onValueChange={setMerchantCategory}>
        <SelectTrigger className="mt-1" data-testid="merchant-category-select"><SelectValue placeholder="Selecione a categoria" /></SelectTrigger>
        <SelectContent>{CATEGORIES.map(cat => <SelectItem key={cat} value={cat}>{cat}</SelectItem>)}</SelectContent>
      </Select>
      <p className="text-xs text-slate-500 mt-1">Seus cupons serão criados nesta categoria</p>
    </div>
    <div><Label>Nome do Contato</Label><Input value={contactName} onChange={e => setContactName(e.target.value)} required data-testid="contact-name-input" className="mt-1" /></div>
    <div>
      <Label>Estado</Label>
      <Select value={state} onValueChange={setState}>
        <SelectTrigger className="mt-1" data-testid="merchant-state-select"><SelectValue placeholder="Selecione" /></SelectTrigger>
        <SelectContent>{STATES.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
      </Select>
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div className="relative" ref={cityRef}>
        <Label>Cidade</Label>
        <Input value={citySearch || city} onChange={e => { setCitySearch(e.target.value); setCity(''); setShowCitySuggestions(true); }}
          onFocus={() => setShowCitySuggestions(true)} placeholder={state ? "Digite a cidade..." : "Selecione o estado primeiro"}
          disabled={!state} required data-testid="city-input" className="mt-1" />
        {showCitySuggestions && filteredCities.length > 0 && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-md shadow-lg max-h-48 overflow-y-auto">
            {filteredCities.map(c => (
              <button key={c} type="button" onClick={() => handleCitySelect(c)}
                className="w-full text-left px-3 py-2 text-sm hover:bg-slate-100 transition-colors">{c}</button>
            ))}
          </div>
        )}
      </div>
      <div><Label>Bairro</Label><Input value={neighborhood} onChange={e => setNeighborhood(e.target.value)} data-testid="merchant-neighborhood-input" className="mt-1" /></div>
    </div>
    <div><Label>Endereco Comercial</Label><Input value={commercialAddress} onChange={e => setCommercialAddress(e.target.value)} required data-testid="address-input" className="mt-1" /></div>

    {/* Plans */}
    <div>
      <Label className="text-lg font-bold text-slate-900 mb-3 block">Escolha seu Plano</Label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {PLANS.map(p => (
          <Card key={p.id}
            className={`cursor-pointer transition-all border-2 ${plan === p.id ? 'ring-2 ring-amber-400 shadow-md' : 'hover:shadow-sm'} ${p.color}`}
            onClick={() => onContractPlan(p.id)} data-testid={`plan-${p.id}`}>
            <CardContent className="py-4 px-4">
              <div className="flex justify-between items-start mb-1">
                <h3 className={`font-bold text-lg ${p.id === 'black' ? 'text-white' : 'text-slate-900'}`}>{p.label}</h3>
                {plan === p.id && <Badge className="bg-green-500 text-white text-xs border-0">Selecionado</Badge>}
              </div>
              <p className={`text-xl font-black ${p.id === 'black' ? 'text-white' : 'text-slate-900'}`}>{p.price}</p>
              <p className={`text-xs mt-1 ${p.id === 'black' ? 'text-slate-300' : 'text-slate-600'}`}>{p.limit}</p>
            </CardContent>
          </Card>
        ))}
      </div>
      {plan !== 'gratuito' && (
        <div className="mt-3 bg-slate-50 border border-slate-200 rounded-lg p-3 flex items-center gap-2">
          <Key className="h-4 w-4 text-slate-600" />
          <p className="text-sm text-slate-600">
            Planos pagos requerem pagamento mensal no cartao de credito. Caso tenha chave de influenciador, insira ao ativar.
          </p>
        </div>
      )}
    </div>
  </div>
);
